import { render } from "./InfoUserBrowsedPage.vue?vue&type=template&id=541a0337&ts=true"
import script from "./InfoUserBrowsedPage.vue?vue&type=script&lang=ts"
export * from "./InfoUserBrowsedPage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__